import React from "react";
import { Typography, Grid } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { PaletteItem } from "../palette/PaletteItem";
import { BlockTypes } from "../../models/block-types";

const benefits = [
  "Test your architecture with real-time feedback",
  "Visualize bottlenecks before they happen in production",
  "Prepare for high-stakes engineering interviews",
  "Experiment with different traffic patterns",
];

export const Benefits: React.FC = () => {
  return (
    <section className="benefits-section">
      <div className="benefits-container">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <div className="benefits-text-content">
              <Typography variant="h3" component="h2" className="section-title left-align">
                Why use the Playground?
              </Typography>
              <Typography variant="h6" className="section-subtitle left-align">
                We believe that interacting dynamically with system architecture is the 
                fastest way to build deep intuition for distributed systems.
              </Typography>
              
              <ul className="benefits-list">
                {benefits.map((benefit, index) => (
                  <li key={index} className="benefit-item">
                    <CheckCircleOutlineIcon className="benefit-icon" />
                    <span className="benefit-text">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <div className="benefits-image-wrapper">
              <div className="benefits-image-container">
                {/* Visual representation of the app canvas inline */}
                <div className="mock-canvas">
                  <div className="float-block mock-lb">
                    <PaletteItem
                      blockType={BlockTypes.LOAD_BALANCER}
                      onItemClick={() => { }}
                      disableInteractivity={true}
                    />
                  </div>
                  <div className="mock-arrow mock-left"></div>
                  <div className="mock-arrow mock-right"></div>
                  <div className="float-block mock-api api-1">
                    <PaletteItem
                      blockType={BlockTypes.APP_SERVER}
                      onItemClick={() => { }}
                      disableInteractivity={true}
                    />
                  </div>
                  <div className="float-block mock-api api-2">
                    <PaletteItem
                      blockType={BlockTypes.LAMBDA}
                      onItemClick={() => { }}
                      disableInteractivity={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};
